// import {
//   ChevronRight,
//   Download,
//   Home,
//   Plus,
//   RotateCw,
//   Upload,
// } from "lucide-react";
// import { Link } from "react-router-dom";
// const Breadcrumb = ({
//   title1,
//   title2,
//   onRefresh,
//   onExport,
//   onImport,
//   showImport,
//   showExport = false,
//   showRefresh = false,
//   showBtn = false,
//   buttonName,
//   onBtnClick,
//   customButton,
// }) => {
//   return (
//     <div className="flex items-center justify-between py-2 border-gray-200">
//       <div className="flex flex-col space-y-2">
//         <div className="text-xl font-bold text-primaryTextColor">{title1}</div>
//         <div className="flex text-sm items-center text-gray-600 font-semibold hover:text-gray-800">
//           <Link to="/dashboard" className="flex items-center">
//             <Home className="w-3.h-3.5 h-3.5  pb-0.5" />
//             Home
//           </Link>
//           <ChevronRight className="w-4 h-4 mr-0.5 " />
//           <span className="">{title2}</span>
//         </div>
//       </div>

//       <div className="flex items-center space-x-3">
//         {showRefresh && (
//           <button
//             onClick={onRefresh}
//             className="flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none active:scale-[0.98]"
//           >
//             <RotateCw className="w-4 h-4 mr-2" />
//             Refresh
//           </button>
//         )}
//         {showExport && (
//           <button
//             onClick={onExport}
//             className="flex items-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700 active:scale-[0.98]"
//           >
//             <Download className="w-4 h-4 mr-2" />
//             Export
//           </button>
//         )}
//         {showBtn && (
//           <button
//             onClick={onBtnClick}
//             className="flex items-center px-4 py-2 text-sm font-medium text-white bg-primaryColor/90 rounded-md hover:bg-primaryColor active:scale-[0.98]"
//           >
//             <Plus className="w-4 h-4 mr-2" />
//             {buttonName}
//           </button>
//         )}
//         {customButton?.()}
//         {showImport && (
//           <button
//             onClick={onImport}
//             className="flex items-center px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
//           >
//             <Upload className="w-4 h-4 mr-2" />
//             Import
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Breadcrumb;

import {
  ChevronRight,
  Download,
  Home,
  Plus,
  RotateCw,
  Upload,
  Sparkles, // Added for that salon touch
} from "lucide-react";
import { Link } from "react-router-dom";

const Breadcrumb = ({
  title1,
  title2,
  onRefresh,
  onExport,
  onImport,
  showImport,
  showExport = false,
  showRefresh = false,
  showBtn = false,
  buttonName,
  onBtnClick,
  customButton,
}) => {
  return (
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between py-6 gap-4 border-b border-pink-50/50">
      {/* Left Side: Titles & Path */}
      <div className="flex flex-col space-y-1">
        <h1 className="text-2xl  font-semibold tracking-tight text-gray-800 flex items-center gap-2">
          {title1}
          {/* <Sparkles className="w-5 h-5 text-pink-400/60" /> */}
        </h1>

        <nav className="flex items-center text-[14px] font-semibold tracking-wide uppercase text-gray-600">
          <Link
            to="/dashboard"
            className="flex items-center hover:text-orange-800 transition-colors duration-200"
          >
            <Home className="w-3.5 h-3.5 mr-1" />
            Home
          </Link>
          <ChevronRight className="w-4 h-4 mx-1 text-orange-800" />
          <span className="bg-clip-text text-transparent bg-gradient-to-tr from-orange-800 via-primaryColor to-brandAccentColor">{title2}</span>
        </nav>
      </div>

      {/* Right Side: Actions */}
      <div className="flex items-center flex-wrap gap-3">
        {showRefresh && (
          <button
            onClick={onRefresh}
            className="p-2.5 text-gray-500 bg-white border border-gray-100 rounded-full shadow-sm hover:text-pink-500 hover:border-pink-100 transition-all active:scale-95"
            title="Refresh"
          >
            <RotateCw className="w-4 h-4" />
          </button>
        )}

        {showImport && (
          <button
            onClick={onImport}
            className="flex items-center px-5 py-2.5 text-sm font-medium text-gray-600 bg-white border border-gray-200 rounded-full hover:bg-gray-50 transition-all active:scale-95"
          >
            <Upload className="w-4 h-4 mr-2 text-pink-400" />
            Import
          </button>
        )}

        {showExport && (
          <button
            onClick={onExport}
            className="flex items-center px-5 py-2.5 text-sm font-medium text-gray-600 bg-white border border-gray-200 rounded-full hover:bg-gray-50 transition-all active:scale-95"
          >
            <Download className="w-4 h-4 mr-2 text-pink-400" />
            Export
          </button>
        )}

        {showBtn && (
          <button
            onClick={onBtnClick}
            className="flex items-center px-6 py-2.5 text-sm font-semibold text-white bg-gradient-to-r from-pink-400 to-rose-400 rounded-full shadow-md shadow-pink-200 hover:shadow-lg hover:from-pink-500 hover:to-rose-500 transition-all active:scale-[0.97]"
          >
            <Plus className="w-4 h-4 mr-2 stroke-[3px]" />
            {buttonName}
          </button>
        )}

        {customButton?.()}
      </div>
    </div>
  );
};

export default Breadcrumb;